export const contacts = {
  support: 'kyle.b.talbot+reliht-support@gmail.com',
};
